import React, { ComponentPropsWithoutRef } from "react";
import classNames from "classnames";
import { Col, Container } from "react-bootstrap";
import Rocket from "./Rocket";
import Milestones from "../Milestones/Milestones";

interface Props extends ComponentPropsWithoutRef<'div'> {}

const Timeline = ({ className, ...htmlProps }: Props) => {
  return (
    <div
      {...htmlProps}
      className={classNames("overflow-hidden position-relative", className)}
    >
      <Col className="d-flex flex-column align-items-start align-items-md-center">
        <Container className="py-10">
          <Milestones />
          <Rocket />
        </Container>
      </Col>
    </div>
  );
};

export default Timeline;
